import React from 'react';
import Heading from '../../../generic-components/Heading';

export const TransactionInitiator = ({ detailsDataObject }: any) => {
  const { initiatorFirstName, initiatorLastName, initiatorPan } = detailsDataObject;
  return (
    <div className='flex items-center gap-[6px] mt-[25px]'>
      <div className='w-[20px] h-[20px] rounded-[50%] bg-[#0E355F] flex items-center justify-center'>
        <Heading
          title={`${initiatorFirstName.substring(0, 1)}${initiatorLastName.substring(0, 1)}`}
          className='font-metricR font-semibold leading-[9px] uppercase text-bw00 text-[10px]'
        />
      </div>
      <Heading
        testId='transaction-details-initiated-by'
        title={`Initiated by ${initiatorFirstName} ${initiatorLastName} ${initiatorPan ? `| Card **${initiatorPan}` : ''}`}
        className='font-metricR pc-md-lg:text-[14px] pc-md:text-[12px] pc-md:text-[12px] text-[12px] text-bw07 leading-[150%]'
      />
    </div>
  );
};
